module.exports = __webpack_public_path__ + "static/13-51e397c9cbfeacc170db8f2430a5afd7.jpg";